import './Button.scss';

export default function Button({onClick, text}) {

    return <p className='button' onClick={onClick}>{text}</p>
}